import useGetVocativeName from '@/legacy-src/components/diagnosis/client/hooks/useGetVocativeName'
import type { ExtendedDiagnosisFields } from '@/legacy-src/components/diagnosis/client/types'
import useTherapistsPreview from '@/legacy-src/hooks/useTherapistsPreview'
import useUser from '@/legacy-src/hooks/useUser'

import { TherapistsPreviewInRegistrationOriginal } from './TherapistsPreviewInRegistrationOriginal'
import { TherapistsPreviewInRegistrationVersionA } from './TherapistsPreviewInRegistrationVersionA'
import { TherapistsPreviewInRegistrationVersionB } from './TherapistsPreviewInRegistrationVersionB'

export interface TherapistsPreviewInRegistrationProps {
  diagnosis: ExtendedDiagnosisFields
  version?: 'versionA' | 'versionB'
}

export const TherapistsPreviewInRegistration = ({ diagnosis, version }: TherapistsPreviewInRegistrationProps) => {
  const { user } = useUser()

  const name = (diagnosis?.name || user?.firstName) ?? ''

  const { data, baseName } = useGetVocativeName(name)
  const nameVocative = data?.vocative ?? baseName

  const { therapist } = useTherapistsPreview(diagnosis)

  if (therapist === undefined) {
    return null
  }

  switch (version) {
    case 'versionA': {
      return (
        <TherapistsPreviewInRegistrationVersionA
          therapist={therapist}
          nameVocative={nameVocative}
          diagnosis={diagnosis}
        />
      )
    }

    case 'versionB': {
      return <TherapistsPreviewInRegistrationVersionB therapist={therapist} nameVocative={nameVocative} />
    }

    default: {
      return <TherapistsPreviewInRegistrationOriginal therapist={therapist} nameVocative={nameVocative} />
    }
  }
}
